import React, { Component } from 'react';
import logo from '../images/uaeu-logo.png';

class BrowserUpgrade extends Component {
    constructor(props){
        super(props);
    }
    render(){
        return(
            <div className="browser-upgrade">
                <div className="bu-inner">
                    <div className="b-bottom">
                        <h2>Upgrade your Browser</h2>
                        <p>For better User Experience and Performance, upgrade your browser to Google Chrome</p>
                        <a className="update-btn" href="http://outdatedbrowser.com" target="_blank">Upgrade your Browser</a>
                    </div>
                </div>
            </div>
        )
    }
}

export default BrowserUpgrade;





// WEBPACK FOOTER //
// ./src/components/BrowserUpgrade.js